import { emptySplitApi } from "./empty-split-api";

export interface ProductsAccount {
  id: number;
  name: string;
  external_id: string;
}

const productsAccountsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductsAccounts: builder.query<ProductsAccount[], void>({
      query: () => ({
        url: `/products-accounts/`,
      }),
      providesTags: ["ProductsAccounts"],
    }),
    getProductsAccount: builder.query<ProductsAccount, number>({
      query: (id) => `/products-accounts/${id}/`,
      providesTags: ["ProductsAccounts"],
    }),
    createProductsAccount: builder.mutation<
      ProductsAccount,
      Omit<ProductsAccount, "id">
    >({
      query: (body) => ({
        url: "/products-accounts/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ProductsAccounts"],
    }),
    updateProductsAccount: builder.mutation<ProductsAccount, ProductsAccount>({
      query: ({ id, ...body }) => ({
        url: `/products-accounts/${id}/`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["ProductsAccounts"],
    }),
    deleteProductsAccount: builder.mutation<void, number>({
      query: (id) => ({
        url: `/products-accounts/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProductsAccounts"],
    }),
  }),
});

export const {
  useGetProductsAccountsQuery,
  useGetProductsAccountQuery,
  useCreateProductsAccountMutation,
  useUpdateProductsAccountMutation,
  useDeleteProductsAccountMutation,
} = productsAccountsApi;
